const prefix = 'page-section';

export const dataHooks = {
  pageSectionTitle: `${prefix}-title`,
  pageSectionSubtitle: `${prefix}-subtitle`,
  pageSectionActionsBar: `${prefix}-actions-bar`,
};
